// extracted by mini-css-extract-plugin
export default {"root":"_2pVCi","loader":"_3PAZ8"};